import { AutomationCard } from "components/AutomationCard/AutomationCard";
import { AutomationTemplateCard } from "components/AutomationTemplateCard /AutomationTemplateCard ";
import { useGetAutomations } from "hooks/useGetAutomations";
import { useGetChannelConnections } from "hooks/useGetChannelConnections";
import { automationsService } from "services/admin/automationsService";
import { toast } from "react-toastify";
import { AIIcon } from "components/_Icons/AIIcon";
import { FaLink, FaPlus, FaTag } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import { Dialog, DialogContent } from "@mui/material";
import { AutomationCreateForm } from "./AutomationCreateForm/AutomationCreateForm";
import { useState } from "react";

const templates = [
  {
    id: 1,
    name: "Чат-бот на кодовое слово",
    description: "Новый способ создания автоматизации без конструктора с любого устройства",
    platform: "INSTAGRAM",
    type: "keyword",
    image: <FaTag />,
    templateID: "keyword",
  },
];

export const Automations = () => {
  const { data: automations, refetch } = useGetAutomations();
  const [isCreateAutomationDialogOpen, setIsCreateAutomationDialogOpen] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState<any>(null);
  const navigate = useNavigate();

  const handleDeleteAutomation = async (automationID: string) => {
    console.log("delete automation", automationID);
    try {
      await automationsService.deleteAutomation(automationID);
      toast.success("Автоматизация удалена");
      refetch();
    } catch (error: any) {
      toast.error("Ошибка при удалении автоматизации");
    }
  };

  const onSubmit = async (data: any) => {
    console.log("submit", data);
    setIsCreateAutomationDialogOpen(false);

    if (selectedTemplate?.templateID === "constructor") {
      // Создаем автоматизация с типом constructor
      const createdAutomation = await automationsService.createAutomation({
        name: data.name,
        channelConnectionID: data.channelConnectionID,
        templateID: selectedTemplate.templateID,
      });
      navigate(`/admin/automations/create/constructor/${createdAutomation.id}`);
    } else {
      navigate(
        `/admin/automations/create/${selectedTemplate.templateID}?name=${data.name}&channelConnectionID=${data.channelConnectionID}`
      );
    }
  };

  const onSelectTemplate = (template: any) => {
    setSelectedTemplate(template);
    setIsCreateAutomationDialogOpen(true);
  };

  return (
    <div>
      <div className="mb-8 flex justify-end">
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            setSelectedTemplate({
              templateID: "constructor",
            });
            setIsCreateAutomationDialogOpen(true);
          }}
          startIcon={<FaPlus size={16} />}
        >
          Создать автоматизацию
        </Button>
      </div>
      <section className="mb-8">
        <h3 className="text-2xl font-bold mb-8">Готовые шаблоны</h3>
        {/* Готовые шаблоны */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {templates.map((template) => (
            <AutomationTemplateCard
              key={template.id}
              template={template}
              onSelect={onSelectTemplate}
            />
          ))}
        </div>
      </section>

      {/* Все автоматизации */}
      <section className="mb-8">
        <h3 className="text-2xl font-bold mb-8">Все автоматизации</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {automations?.map((automation: any) => (
            <AutomationCard
              key={automation.id}
              automation={automation}
              onDelete={handleDeleteAutomation}
            />
          ))}
        </div>
      </section>

      {/* Dialog for create automation */}
      <Dialog
        open={isCreateAutomationDialogOpen}
        onClose={() => setIsCreateAutomationDialogOpen(false)}
      >
        <DialogContent>
          <AutomationCreateForm onSubmit={onSubmit} />
        </DialogContent>
      </Dialog>
    </div>
  );
};
